import { defineComponent as _defineComponent } from 'vue'
import { ApiValidationErrorViewModel } from "@/viewModels/apiErrorViewModel";
import { PropType, reactive, toRefs, inject } from "vue";
import { CommunityTalkStore, isValidCommunityTalkStoreKey } from "@/store/communityTalk/communityTalkStore";
import AppConst from "@/modules/const";
import CustomInput from "../common/form/CustomInput.vue";
import CustomLabel from "./CustomLabel.vue";

interface State {
	/**
	 * 入力ニックネームの内容。
	 */
	inputNickName: string;
}
// reactiveな変数宣言

export default /*#__PURE__*/_defineComponent({
  props: {
	/**
	 * CommunityTalkStoreのInject用キー。
	 */
	communityTalkStoreKey: {
		type: String,
		required: true,
		default: "",
	},
	/**
	 * 投稿種類。
	 * トークルームとしてのニックネーム: `TalkRoom`
	 * リプライとしてのニックネーム: `Reply`
	 */
	postType: {
		type: String,
		required: true,
		default: "TalkRoom",
		validator(val: string) {
			return ["TalkRoom", "Reply"].includes(val);
		},
	},
	/**
	 * 入力欄を無効化するかどうか。
	 */
	disabled: {
		type: Boolean,
		required: false,
		default: false,
	},
	/**
	 * 親コンポーネントからのAPIエラーオブジェクト。
	 */
	apiValidationErrorViewModel: {
		type: Object as PropType<ApiValidationErrorViewModel | null>,
		required: true,
		default: null,
	},
	/**
	 * 入力必須エラーを表示するかどうか。
	 */
	showRequiredError: {
		type: Boolean,
		required: false,
		default: false,
	},
},
  setup(__props, { expose }) {
  expose()

const props = __props
/**
 * ニックネーム投稿コンポーネント。
 * 入力されたニックネームは、Store層(+LocalStorage)へ保持される。
 * バリデーションエラー表示にも対応。
 */



// Storeの初期化処理
if (!isValidCommunityTalkStoreKey(props.communityTalkStoreKey)) {
	// なんらかの原因でInjectKeyにエラーが発生していた場合は強制終了
	throw new Error(`InjectKeyにエラーが発生しました。${props.communityTalkStoreKey.toString()}`);
}
const communityTalkStore = inject(props.communityTalkStoreKey) as CommunityTalkStore;

const state = reactive<State>({
	inputNickName: communityTalkStore.getCommunityTalkUserNickName(),
});
const { inputNickName } = toRefs(state);

const name = props.postType === "TalkRoom" ? "nickName" : "reply.NickName";

// 入力欄変更時、Storeへ投稿者プロフィール情報を反映
const onChange = (): void => {
	communityTalkStore.setCommunityTalkUserNickName(state.inputNickName);
};

/**
 * ニックネームの投稿最大文字長。
 */
const nickNameMaxLength = AppConst.COMMUNITY_TALK_USER_NICKNAME_MAX_LENGTH;

/**
 * ニックネームが必須かどうか。
 */
const isRequiredNickname = communityTalkStore.getGeneralSettings().nicknameRequiredSetting === "Required";

const __returned__ = { props, communityTalkStore, state, inputNickName, name, onChange, nickNameMaxLength, isRequiredNickname, CustomInput, CustomLabel }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})